import { IUser } from '@cod-monorepo/interfaces';

export class UserMappingOperations {
    public static mapToLabeledUser(users: IUser[]): { value: IUser; label: string }[] {
        return users.map(user => ({
            value: user,
            label: `${user.firstName} ${user.lastName} (${user.gid})`
        }));
    }
}
